
import gql from 'graphql-tag';
import productPromotionFragment from '~/apollo/fragments/productPromotionFragment';
import termCancerPlanScenariosQuery from '~/apollo/queries/product/termCancerPlanScenario.gql';
import termCancerTooltips from '~/apollo/queries/product/tooltips/termCancerTooltips';
import commonProductDetailMixins from '~/mixins/commonProductDetailMixins.js';
import productPromotionMixins from '~/mixins/productPromotionMixins.js';
import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';

export default {
  mixins: [commonProductDetailMixins, productPromotionMixins, productInsuranceNameMixins],

  data() {
    return {
      termCancerPlanScenarios: null,
      loading: 0,
      currentLocale: this.$normalizeLocale(this.$i18n.locale),
    };
  },
  // page component definitions
  apollo: {
    $loadingKey: 'loading',
    termCancerPlanScenarios: {
      query: gql`
        ${termCancerPlanScenariosQuery}
        ${productPromotionFragment}
      `,
      prefetch: true,
      variables() {
        return {
          scenario_code: this.$route.params.slug,
          locale: this.currentLocale,
        };
      },
    },
    termCancerTooltips: {
      query: termCancerTooltips,
      prefetch: true,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
      },
      update(data) {
        return this.$normalizeStrapi(data.infoTooltip.data);
      },
    },
  },
  computed: {
    simpleItems() {
      if (this.termCancerPlanScenarios?.data[0]) {
        const item = this.termCancerPlanScenarios.data[0];
        let promotionPrices = Array;
        promotionPrices = [];

        let discountedTenYearAvgPremium = null;
        let promotions = null;
        let promotion = null;
        let promotion_last_call = null;

        const planName = item.attributes.term_cancer_plan.data.attributes.term_cancer_plan_translations.data[0].attributes.name;
        const insurer = item.attributes.term_cancer_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;  
        let decoderCTALink = this.$generateWhatsappCTALink(this.$t('products.termcancer.tcr_categoryName'), insurer, planName);
        let decoderCTAText = '';

        // check scenario level promo first , then plan level promotion 
        if (item.attributes.product_promotions.data?.length > 0) {
          promotions = item.attributes.product_promotions.data;
        }
        if (item.attributes.term_cancer_plan.data.attributes.product_promotions.data?.length > 0) {
          promotions = item.attributes.term_cancer_plan.data.attributes.product_promotions.data;
        }
        
        if(promotions != null) {
          promotion = this.checkPromotionValid(promotions);
          promotion_last_call = this.checkPromotionLastCall(promotion);

          if (!promotion) {
            promotion = null;
          } else {
            if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
              decoderCTALink =
                promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;
              decoderCTAText = this.$t('products.product_website');
            }
            const discounts = promotion.attributes.DiscountPercentage;
            if (discounts) {
              // calculate promotion price and avg premium
              let originalPrices = Array;
              originalPrices = [];
              for (let i = 0; i < 10; i++) {
                originalPrices[i] = item.attributes['premium_display_' + parseInt(i + 1)];
              }
              const calulatedValue = this.calculateDiscountedPremium(originalPrices, discounts);

              promotionPrices = calulatedValue.promotionPrices;
              discountedTenYearAvgPremium = calulatedValue.discountedTenYearAvgPremium;

              if (discountedTenYearAvgPremium === parseInt(item.attributes.ten_year_average_premium.toFixed(0))) {
                discountedTenYearAvgPremium = null;
              }
            }
          }
        }

        const filteredTranslations = this.getFilteredTranslations(item.attributes.term_cancer_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
        .insurance_company_translations.data[0].attributes.localizations.data);

        return {
          currency: item.attributes.currency.data.attributes.code,
          scenario_code: item.attributes.scenario_code,
          sum_assured: item.attributes.sum_assured,
          age: item.attributes.age,
          cancer_score: item.attributes.cancer_score,
          renewal_term: item.attributes.renewal_term,
          first_year_premium: item.attributes.first_year_premium,
          ten_year_average_premium: item.attributes.ten_year_average_premium,

          overall_star: item.attributes.term_cancer_plan.data.attributes.overall_star,

          // plan
          plan_name: planName,
          underwriting_text:
            item.attributes.term_cancer_plan.data.attributes.term_cancer_plan_translations.data[0].attributes
              .underwriting_text,

          // insurer
          insurer_name_first:
            item.attributes.term_cancer_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
              .insurance_company_translations.data[0].attributes.name,
          insurer_name_second:
            filteredTranslations[0].attributes.name,
          insurer_logo:
            item.attributes.term_cancer_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
              .logo,
          insurer_code:
            item.attributes.term_cancer_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
              .code,

          product_promotion: promotion,
          promotion_prices: promotionPrices,
          promotion_last_call: promotion_last_call,

          discounted_ten_year_avg_premium: discountedTenYearAvgPremium,
          decoder_cta_link: decoderCTALink,
          decoder_cta_text: decoderCTAText,

          online_purchase: item.attributes.term_cancer_plan.data.attributes.online_purchase,
          no_cover_maj_illness: item.attributes.term_cancer_plan.data.attributes.no_cover_maj_illness,
          no_standard_ci_cover: item.attributes.term_cancer_plan.data.attributes.no_standard_ci_cover,
          no_standard_ci_coverex: item.attributes.term_cancer_plan.data.attributes.no_standard_ci_coverex,

          issue_age_from: item.attributes.issue_age_from,
          issue_age_from_unit: item.attributes.issue_age_from_unit,
          issue_age_to: item.attributes.issue_age_to,
          issue_age_to_unit: item.attributes.issue_age_to_unit,
          premium_display_1: item.attributes.premium_display_1,
          premium_display_2: item.attributes.premium_display_2,
          premium_display_3: item.attributes.premium_display_3,
          premium_display_4: item.attributes.premium_display_4,
          premium_display_5: item.attributes.premium_display_5,
          premium_display_6: item.attributes.premium_display_6,
          premium_display_7: item.attributes.premium_display_7,
          premium_display_8: item.attributes.premium_display_8,
          premium_display_9: item.attributes.premium_display_9,
          premium_display_10: item.attributes.premium_display_10,
          early_cancer: item.attributes.early_cancer,
          max_cover: item.attributes.max_cover,
          max_cover_unit: item.attributes.max_cover_unit,

          // // ***** Cancer Terms *****
          cancer_payouts: item.attributes.term_cancer_plan.data.attributes.term_cancer_c_payouts.data,
          cancer_c_term_values: item.attributes.term_cancer_plan.data.attributes.term_cancer_c_term_values.data,
          cancer_g_term_values: item.attributes.term_cancer_plan.data.attributes.term_cancer_g_term_values.data,

          scenarioId: item.id,
        };
      }
      return null;
    },
    product() {
      if (!this.simpleItems) return null;

      return {
        highlightSection: {
          scenarioCode: this.simpleItems.scenario_code,
          scenarioId: this.simpleItems.scenarioId,
          showFiveStarBadge: this.$formatShowFiveStarBadge(this.simpleItems.overall_star),
          productName: this.simpleItems.plan_name,
          insuranceCompany: {
            name: this.simpleItems.insurer_name_first + ' | ' + this.simpleItems.insurer_name_second,
            code: this.simpleItems.insurer_code,
            logoSrc: this.simpleItems.insurer_logo?.data?.attributes?.url,
            logoAlt: this.simpleItems.insurer_name_first,
          },
          userRating: {
            score: this.simpleItems.overall_star,
            numberOfRatedUser: '0',
          },
          tenlifeScore: {
            score: parseFloat(this.simpleItems.cancer_score),
            description: this.$t('products.termcancer.tcr_termCancerScore'),
            toolTipHtml: this.getTooltipContentByKey('tcr_termCancerScore'),
          },
          features: [
            {
              text: this.getRenewal(this.$t('products.termcancer.tcr_renewalUnit'), this.simpleItems.renewal_term),
              type: 'renewal_term',
            },
            {
              text: this.simpleItems.underwriting_text,
              type: 'underwriting',
            },
          ],
          keyItems: [
            {
              value: this.simpleItems.early_cancer > 0,
              key: this.$t('products.termcancer.tcr_earlyCancer'),
              topSubText: '',
              toolTipHtml: '',
              symbolValue: this.simpleItems.early_cancer > 0,
              originalValue: '',
            },
            {
              value: this.simpleItems.discounted_ten_year_avg_premium
                ? this.$formatPrice(this.simpleItems.discounted_ten_year_avg_premium)
                : this.$formatPrice(this.simpleItems.ten_year_average_premium),
              key: this.$t('products.termcancer.tcr_tenYearAvgPremium'),
              topSubText: this.simpleItems.currency,
              toolTipHtml: '',
              symbolValue: '',
              originalValue: this.simpleItems.discounted_ten_year_avg_premium
                ? this.$formatPrice(this.simpleItems.ten_year_average_premium)
                : '',
            },
            {
              value: this.simpleItems.promotion_prices[0]
                ? this.$formatPrice(this.simpleItems.promotion_prices[0])
                : this.$formatPrice(this.simpleItems.first_year_premium),
              key: this.$t('products.termcancer.tcr_firstYearPremium'),
              topSubText: this.simpleItems.currency,
              toolTipHtml: '',
              symbolValue: '',
              originalValue: this.simpleItems.promotion_prices[0]
                ? this.$formatPrice(this.simpleItems.first_year_premium)
                : '',
            },
          ],
          mainButtonCTA: {
            text: this.simpleItems.decoder_cta_text,
            link: this.simpleItems.decoder_cta_link,
          },
        },
        detailSection: {
          details: [
            {
              id: 0,
              sectionTitle: this.$t('products.termcancer.tcr_overview'),
              keyValues: [
                {
                  key: this.$t('products.termcancer.tcr_termCancerScore'),
                  value: this.$formatScore(this.simpleItems.cancer_score) + ' / 10',
                  keyToolTipHtml: this.getTooltipContentByKey('tcr_termCancerScore'),
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.termcancer.tcr_sumAssured'),
                  value: this.simpleItems.currency + ' ' + this.$formatPrice(this.simpleItems.sum_assured),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.termcancer.tcr_renewalTerm'),
                  value: this.getRenewal(this.$t('products.renewalUnit'), this.simpleItems.renewal_term),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.termcancer.tcr_tenYearAvgPremium'),
                  value: this.simpleItems.discounted_ten_year_avg_premium
                    ? this.simpleItems.currency +
                    ' ' +
                    this.$formatPrice(this.simpleItems.discounted_ten_year_avg_premium)
                    : this.simpleItems.currency + ' ' + this.$formatPrice(this.simpleItems.ten_year_average_premium),
                  originalValue: this.simpleItems.discounted_ten_year_avg_premium
                    ? this.simpleItems.currency + ' ' + this.$formatPrice(this.simpleItems.ten_year_average_premium)
                    : '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.termcancer.tcr_issueAge'),
                  value: this.$formatIssueAgeRangeByUnit(
                    this.currentLocale,
                    this.simpleItems.issue_age_from,
                    this.simpleItems.issue_age_from_unit,
                    this.getFromLabel(this.simpleItems),
                    this.simpleItems.issue_age_to,
                    this.simpleItems.issue_age_to_unit,
                    this.$t('products.ageUnit'),
                    this.$t('products.to')
                  ),
                  // value: this.$formatAgeRange(this.currentLocale, this.simpleItems.issue_age_from_text, this.simpleItems.issue_age_to_text, this.$t('products.ageUnit'), this.$t('products.to')),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.termcancer.tcr_maximumCoveredAge'),
                  value: this.$formatAge(this.currentLocale, this.simpleItems.max_cover, this.$t('products.ageUnit')),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.termcancer.tcr_onlinePurchase'),
                  value: this.simpleItems.online_purchase,
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
              ],
            },
            {
              id: 1,
              sectionTitle: this.$t('products.termcancer.tcr_cancerCoverageScore'),
              keyValues: [
                {
                  key: this.$t('products.termcancer.tcr_cancerScore'),
                  value: this.$formatScore(this.simpleItems.cancer_score) + ' / 10',
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.termcancer.tcr_cancerTerms'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.getCancerTerm(this.simpleItems.cancer_c_term_values, 'C001').label,
                      value: this.getCancerTerm(this.simpleItems.cancer_c_term_values, 'C001').value,
                    },
                    {
                      key: this.getCancerTerm(this.simpleItems.cancer_c_term_values, 'C002').label,
                      value: this.getCancerTerm(this.simpleItems.cancer_c_term_values, 'C002').value,
                    },
                    {
                      key: this.getCancerGeneralTerm(this.simpleItems.cancer_g_term_values, 'T002').label,
                      value: this.getCancerGeneralTerm(this.simpleItems.cancer_g_term_values, 'T002').value,
                    },
                    {
                      key: this.getCancerGeneralTerm(this.simpleItems.cancer_g_term_values, 'T001').label,
                      value: this.getCancerGeneralTerm(this.simpleItems.cancer_g_term_values, 'T001').value,
                    },
                  ],
                },
                {
                  key: this.$t('products.termcancer.tcr_payoutofMajorCancerinSumAssured'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP001').label,
                      value:
                        this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP001').value > 0
                          ? this.$formatPercentage(this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP001').value)
                          : false,
                    },
                    {
                      key: this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP002').label,
                      value:
                        this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP002').value > 0
                          ? this.$formatPercentage(this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP002').value)
                          : false,
                    },
                    {
                      key: this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP003').label,
                      value:
                        this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP003').value > 0
                          ? this.$formatPercentage(this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP003').value)
                          : false,
                    },
                    {
                      key: this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP004').label,
                      value:
                        this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP004').value > 0
                          ? this.$formatPercentage(this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP004').value)
                          : false,
                    },
                    {
                      key: this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP005').label,
                      value:
                        this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP005').value > 0
                          ? this.$formatPercentage(this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP005').value)
                          : false,
                    },
                    {
                      key: this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP006').label,
                      value:
                        this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP006').value > 0
                          ? this.$formatPercentage(this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP006').value)
                          : false,
                    },
                    {
                      key: this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP007').label,
                      value:
                        this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP007').value > 0
                          ? this.$formatPercentage(this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP007').value)
                          : false,
                    },
                    {
                      key: this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP008').label,
                      value:
                        this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP008').value > 0
                          ? this.$formatPercentage(this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP008').value)
                          : false,
                    },
                    {
                      key: this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP009').label,
                      value:
                        this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP009').value > 0
                          ? this.$formatPercentage(this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP009').value)
                          : false,
                    },
                    {
                      key: this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP010').label,
                      value:
                        this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP010').value > 0
                          ? this.$formatPercentage(this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP010').value)
                          : false,
                    },
                  ],
                },
                {
                  key: this.$t('products.termcancer.tcr_payoutofEarlyCancerinSumAssured'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP011').label,
                      value:
                        this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP011').value > 0
                          ? this.$formatPercentage(this.getCancerPayout(this.simpleItems.cancer_payouts, 'CP011').value)
                          : false,
                    },
                  ],
                },
              ],
            },

            {
              id: 2,
              sectionTitle: this.$t('products.termcancer.tcr_premium'),
              keyValues: [
                {
                  key: this.$t('products.termcancer.tcr_tenYearAvgPremium'),
                  value: this.simpleItems.discounted_ten_year_avg_premium
                    ? this.simpleItems.currency +
                    ' ' +
                    this.$formatPrice(this.simpleItems.discounted_ten_year_avg_premium)
                    : this.simpleItems.currency + ' ' + this.$formatPrice(this.simpleItems.ten_year_average_premium),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.termcancer.tcr_1stYearPremium'),
                  value: this.simpleItems.currency + ' ' + this.$formatPrice(this.getPremium(this.simpleItems, 1)),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.termcancer.tcr_2ndYearPremium'),
                  value: this.simpleItems.currency + ' ' + this.$formatPrice(this.getPremium(this.simpleItems, 2)),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.termcancer.tcr_3rdYearPremium'),
                  value: this.simpleItems.currency + ' ' + this.$formatPrice(this.getPremium(this.simpleItems, 3)),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.termcancer.tcr_4thYearPremium'),
                  value: this.simpleItems.currency + ' ' + this.$formatPrice(this.getPremium(this.simpleItems, 4)),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.termcancer.tcr_5thYearPremium'),
                  value: this.simpleItems.currency + ' ' + this.$formatPrice(this.getPremium(this.simpleItems, 5)),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.termcancer.tcr_6thYearPremium'),
                  value: this.simpleItems.currency + ' ' + this.$formatPrice(this.getPremium(this.simpleItems, 6)),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.termcancer.tcr_7thYearPremium'),
                  value: this.simpleItems.currency + ' ' + this.$formatPrice(this.getPremium(this.simpleItems, 7)),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.termcancer.tcr_8thYearPremium'),
                  value: this.simpleItems.currency + ' ' + this.$formatPrice(this.getPremium(this.simpleItems, 8)),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.termcancer.tcr_9thYearPremium'),
                  value: this.simpleItems.currency + ' ' + this.$formatPrice(this.getPremium(this.simpleItems, 9)),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.termcancer.tcr_10thYearPremium'),
                  value: this.simpleItems.currency + ' ' + this.$formatPrice(this.getPremium(this.simpleItems, 10)),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
              ],
            },
          ],
          promotion: {
            category:
              this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
                ?.PromotionCategory,
            title:
              this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
                ?.PromotionTitle,
            ctaButtonLink:
              this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
                ?.CTAButtonLink,
            ctaButtonText:
              this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
                ?.CTAButtonText,
            promotionId: this.simpleItems.product_promotion?.id,
            scenarioId: this.simpleItems.scenarioId,
            lastCall: this.simpleItems.promotion_last_call

          },
        },
      };
    },
  },

  methods: {
    getCancerPayout(payouts, code) {
      let tmpPayout = null;
      tmpPayout = payouts.filter((payout) => {
        return code === payout.attributes.term_ci_cancer_term.data.attributes.code;
      });
      return {
        label:
          tmpPayout[0].attributes.term_ci_cancer_term.data.attributes.term_ci_cancer_term_translations.data[0]
            .attributes.description,
        value: tmpPayout[0].attributes.cp_value,
      };
    },

    getCancerTerm(terms, code) {
      let tmpTerm = null;
      tmpTerm = terms.filter((term) => {
        return code === term.attributes.term_ci_cancer_term.data.attributes.code;
      });
      return {
        label:
          tmpTerm[0].attributes.term_ci_cancer_term.data.attributes.term_ci_cancer_term_translations.data[0].attributes
            .description,
        value: tmpTerm[0].attributes.ct_value,
      };
    },

    getCancerGeneralTerm(terms, code) {
      let tmpTerm = null;
      tmpTerm = terms.filter((term) => {
        return code === term.attributes.term_cancer_g_term.data.attributes.code;
      });
      return {
        label:
          tmpTerm[0].attributes.term_cancer_g_term.data.attributes.term_cancer_g_term_translations.data[0].attributes
            .description,
        value: tmpTerm[0].attributes.gt_value,
      };
    },

    getHeartPayout(payouts, code) {
      let tmpPayout = null;
      tmpPayout = payouts.filter((payout) => {
        return code === payout.attributes.term_ci_heart_term.data.attributes.code;
      });
      return {
        label:
          tmpPayout[0].attributes.term_ci_heart_term.data.attributes.term_ci_heart_term_translations.data[0].attributes
            .description,
        value: tmpPayout[0].attributes.hp_value,
      };
    },

    getRenewal(label, renewalTerm) {
      if (renewalTerm === 1) {
        return this.$t('products.annualRenewal');
      }
      return label.replace('$num', renewalTerm);
    },

    getPremium(item, year) {
      if (item.promotion_prices[parseInt(year - 1)]) {
        return item.promotion_prices[parseInt(year - 1)];
      } else {
        return item['premium_display_' + year];
      }
    },

    getFromLabel(item) {
      if (item.issue_age_from_unit === 'day') {
        return this.$t('products.dayUnit');
      } else if (item.issue_age_from_unit === 'month') {
        return this.$t('products.monthUnit');
      } else {
        return this.$t('products.ageUnit');
      }
    },

    getTooltipContentByKey(mKey) {
      return this.termCancerTooltips?.TermCancer?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
    },
  },
};
